import { getWelcomeExperience } from '@library/api-onboarding-welcome'
import useSWR from 'swr'

export type WelcomeHeaderData = {
  title: string
  subtitle: string
}

export type WelcomeExperience = {
  header: WelcomeHeaderData
}

export const WELCOME_EXPERIENCE_API_KEY = 'api/activate/onboarding/welcome/v1'

const EMPTY_HEADER: WelcomeHeaderData = {
  title: '',
  subtitle: '',
}

export const useWelcomeExperience = () => {
  const { data, error } = useSWR(WELCOME_EXPERIENCE_API_KEY, getWelcomeExperience)

  return {
    header: {
      title: data?.header?.title ?? EMPTY_HEADER.title,
      subtitle: data?.header?.sub_title ?? EMPTY_HEADER.subtitle,
    },
    error,
  }
}
